import React, { Component } from "react";
import Previews from "./addImage";
import EditorsForAddComponent from "./EditorsForAddComponent";

export default class AddComponent extends Component {
  state = {
    numChildren: 0,
    allChildren: [],
    mainData: []
  };

  saveData = (data, id, type, editorId) => {
    console.log(data)
    // var blocks = data.blocks;
    // var extractedData = {};
    // for (let i = 0; i < blocks.length; i++) {
    //   extractedData.id = editorId;
    //   if (i == 0) {
    //     extractedData.heading = blocks[i].text;
    //   } else {
    //     extractedData.discription = blocks[i].text;
    //   }
    // }

    // var exist = false;
    // var subDataExist = false
    // var mainData = this.state.mainData;

    // var obj = {
    //   id: id,
    //   type: type,
    //   data: []
    // };

    // for (let i = 0; i < mainData.length; i++) {
    //   if (mainData[i].id == id) {
    //     var subData = mainData[i].data;
    //     for (let j = 0; j < subData.length; j++) {
    //       if (subData[j].id == editorId) {
    //         subDataExist = true
    //         subData[j] = extractedData;
    //       }
    //     }
    //     if(subDataExist == false){
    //       subData.push(extractedData)
    //     }
    //     exist = true;
    //   }
    // }

    // if (exist === false) {
    //   mainData.push(obj);
    // }
    // console.log(blocks)

    // this.setState({ mainData: mainData });
    // console.log(this.state.mainData)
  };

  render() {
    const children = [];

    for (let j = 0; j < this.state.allChildren.length; j++) {
      if (this.state.allChildren[j].type == "one") {
        children.push(
          <ChildComponentOne
            key={j}
            number={this.state.allChildren[j].id}
            type={this.state.allChildren[j].type}
            saveData={this.saveData}
          />
        );
      } else if (this.state.allChildren[j].type == "two") {
        children.push(
          <ChildComponentTwo
            key={j}
            number={this.state.allChildren[j].id}
            type={this.state.allChildren[j].type}
            saveData={this.saveData}
          />
        );
      } else if (this.state.allChildren[j].type == "three") {
        children.push(
          <ChildComponentThree
            key={j}
            number={this.state.allChildren[j].id}
            type={this.state.allChildren[j].type}
            saveData={this.saveData}
          />
        );
      }
    }

    return (
      <ParentComponent addChild={this.onAddChild}>{children}</ParentComponent>
    );
  }

  onAddChild = (type, id) => {
    console.log(type, id);
    this.setState({
      numChildren: this.state.numChildren + 1
    });

    const allChildren = this.state.allChildren;
    if (type == "one") {
      var obj = {};
      obj.id = id;
      obj.type = "one";
      allChildren.push(obj);
    } else if (type == "two") {
      var obj = {};
      obj.id = id;
      obj.type = "two";
      allChildren.push(obj);
    } else if (type == "three") {
      var obj = {};
      obj.id = id;
      obj.type = "three";
      allChildren.push(obj);
    }
  };
}

const ParentComponent = props => (
  <section>
    <div class="container main-container bg-light m-5 mx-auto fade-in">
      <div class="d-flex justify-content-center align-items-center flex-column">
        <div class="main-wrap row w-100 justify-content-center align-items-center">
          {props.children}
        </div>

        <hr />

        <h5 class="add-content edit-mode">Add your content</h5>

        <div class="column edit-mode details py-3 row w-50 mx-auto justify-content-center">
          <button
            id="one-column"
            class="col-md-3 m-1 btn btn-secondary mx-1"
            onClick={props.addChild.bind(this, "one", props.children.length)}
          >
            One Column
          </button>
          <button
            id="two-column"
            class="col-md-3 m-1 btn btn-secondary mx-1"
            onClick={props.addChild.bind(this, "two", props.children.length)}
          >
            Two Column
          </button>
          <button
            id="three-column"
            class="col-md-3 m-1 btn btn-secondary mx-1"
            onClick={props.addChild.bind(this, "three", props.children.length)}
          >
            Three Column
          </button>
        </div>
      </div>
    </div>
  </section>
);

const text = "<h4> <b>Add your title.</b></h4>" + "<p>Add your description</p>";

const ChildComponentOne = props => (
  <div className="col-md-12 my-3 text-center px-3">
    <div className="card p-1">
      <Previews></Previews>
      <div className="p-0 px-3">
        <EditorsForAddComponent text={text} data={props} editorId="1"></EditorsForAddComponent>
        {/* <div className="delete-button text-danger">
    <i class="fas fa-times"></i>
    </div> */}
      </div>
    </div>
  </div>
);
const ChildComponentTwo = props => (
  <div className="row mx-2">
    <div className="col-md-6 my-3 text-center px-2">
      <div className="card p-1">
        <Previews></Previews>
        <div className="p-0 px-3">
          <EditorsForAddComponent text={text} data={props} editorId="1"></EditorsForAddComponent>
          {/* <div className="delete-button text-danger">
    <i class="fas fa-times"></i>
    </div> */}
        </div>
      </div>
    </div>
    <div className="col-md-6 my-3 text-center px-2">
      <div className="card p-1">
        <Previews></Previews>
        <div className="p-0 px-3">
          <EditorsForAddComponent text={text} data={props} editorId="2"></EditorsForAddComponent>
          {/* <div className="delete-button text-danger">
    <i class="fas fa-times"></i>
    </div> */}
        </div>
      </div>
    </div>
  </div>
);
const ChildComponentThree = props => (
  <div className="row mx-2">
    <div className="col-md-4 my-3 text-center px-2">
      <div className="card p-1">
        <Previews></Previews>
        <div className="p-0 px-3">
          <EditorsForAddComponent text={text} data={props} editorId="1"></EditorsForAddComponent>
          {/* <div className="delete-button text-danger">
    <i class="fas fa-times"></i>
    </div> */}
        </div>
      </div>
    </div>
    <div className="col-md-4 my-3 text-center px-2">
      <div className="card p-1">
        <Previews></Previews>
        <div className="p-0 px-3">
          <EditorsForAddComponent text={text} data={props} editorId="2"></EditorsForAddComponent>
          {/* <div className="delete-button text-danger">
    <i class="fas fa-times"></i>
    </div> */}
        </div>
      </div>
    </div>
    <div className="col-md-4 my-3 text-center px-2">
      <div className="card p-1">
        <Previews></Previews>
        <div className="p-0 px-3">
          <EditorsForAddComponent text={text} data={props} editorId="3"></EditorsForAddComponent>
          {/* <div className="delete-button text-danger">
            <i class="fas fa-times"></i>
          </div> */}
        </div>
      </div>
    </div>
  </div>
);
